import React from 'react';

const StepNavigation = ({
  onBack,
  onContinue,
  continueDisabled,
  backDisabled = false,
  backLabel = 'Cancel',
  continueLabel = 'Continue',
}) => (
  <div className="hidden justify-between md:flex">
    <button
      type="button"
      onClick={onBack}
      disabled={backDisabled}
      className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {backLabel}
    </button>
    <button
      type="button"
      onClick={onContinue}
      disabled={continueDisabled}
      className="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {continueLabel}
    </button>
  </div>
);

export default StepNavigation;
